document.addEventListener("DOMContentLoaded", function(){

let items = document.querySelectorAll(".yumi-bundle-item");

let bundles = {};

items.forEach(item=>{

let bundle =
item.dataset.bundle;

let type =
item.dataset.bundleType;

if(!bundle) return;

if(!bundles[bundle]){
bundles[bundle]={
main:null,
addons:[]
};
}

if(type=="Main Product"){
bundles[bundle].main=item;
}else{
bundles[bundle].addons.push(item);
}

});

Object.keys(bundles).forEach(bundle=>{

let group=bundles[bundle];

if(!group.main) return;

group.addons.forEach(addon=>{
group.main.after(addon);
});

});

});